import styled from 'styled-components';

export const Wrapper = styled.div`
  align-items: center;
  background-color: #fff;
  border: none;
  flex-flow: row nowrap;
  height: 3.125rem;
  justify-content: center;
  margin: 1.5rem 0;
  outline: none;
  position: relative;
  display: flex;
  max-width: 32rem;
  width: 100%;

  @media (min-width: 36rem) {
    max-width: 100%;
    width: 32rem;
  }

  @media (min-width: 48rem) {
    max-width: 100%;
    width: 43.125rem;
  }

  @media (min-width: 62rem) {
    max-width: 100%;
    width: 27rem;
  }
`;

export const Title = styled.span`
  position: absolute;
  top: -1.5rem;
  left: 0;
  letter-spacing: 0.08rem;
  font-size: 0.875rem;
`;

export const Input = styled.input`
  height: 3.125rem;
  width: 100%;
  padding: 0.8125rem 1.25rem;
  font-size: 1rem;
  letter-spacing: 0;
  text-transform: none;
  margin: 0.6rem 0;
  outline: none;
  border: none;
  font-family: inherit;
  display: flex;

  &:focus {
    outline: 3px solid #b5d4f5;
  }
`;
